module.exports = __webpack_public_path__ + "static/media/Thailand-6.ac81d8ef.jpg";